@if (target) {
    <!-- @if(!isMaintenaceTaken(target)){ -->
        @if (isDurationTarget(target)) {
        <app-box-duration [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-duration>
        }
        @if (isFrequencyTarget(target)) {
        <app-box-frequency [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-frequency>
        }
        @if (isGroupedFrequencyTarget(target) || isConditionalDiscriminationTarget(target) || isTaskAnalysisTarget(target)) {
        <app-box-grouped [isBottomBox]="isBottomBox" [target]="target" [subTargetsDictionary]="subTargetsDictionary"
            [subTargets]="subTargetsDictionary[target.ID ?? 0]" [isChain]="isTaskAnalysisTarget(target)" 
            [promptSchedules]="promptSchedules??[]" [allPromptCodes]="allPromptCodes" [isPreview]="isPreview"></app-box-grouped>
        }
        @if (isDttTarget(target)) {
        <app-box-dtt [isBottomBox]="isBottomBox" [target]="target"
            [options]="promptCodes" [enabled]="enabled" [allPromptCodes]="allPromptCodes" [promptSchedule]="promptSchedule" [isPreview]="isPreview"></app-box-dtt>
        }
        @if (isEchoicTarget(target)) {
        <app-box-echoic [isBottomBox]="isBottomBox" [target]="target" 
            [options]="promptCodes" [allPromptCodes]="allPromptCodes" [promptSchedule]="promptSchedule" [isPreview]="isPreview"></app-box-echoic>
        }
        @if (isFluencyRateTarget(target)) {
            <app-box-fluencyrate [isBottomBox]="isBottomBox"  [target]="target" [isPreview]="isPreview"></app-box-fluencyrate>
        }
        @if (isQuantityTarget(target)) {
            <app-box-quantity [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-quantity>
        }
        @if (isCurrencyTarget(target)) {
            <app-box-currency [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-currency>
        }
        @if (isAnecdotalTarget(target)) {
            <app-box-anecdotal [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-anecdotal>
        }
        
        @if (isIntervalTarget(target)) {
            <app-box-interval [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-interval>
        }
        @if (isToiletingTarget(target)) {
            <app-box-toileting [isBottomBox]="isBottomBox" [target]="target" [isPreview]="isPreview"></app-box-toileting>
        }
    }
<!-- } -->